module.exports = __webpack_public_path__ + "static/media/cutsglare_german_00288.12fd30ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/hdpolarized/axis/de/cutsglare_german_00288.png
// module id = 1317
// module chunks = 0